"use client";

import { type Context, createContext, useContext } from "react";

/** Screen-reader labels of built-in chrome (close X). The app provides translations. */
export interface UiLabels {
  readonly close: string;
}

// i18n-exempt: fallback only outside the app's IntlProvider (global error page).
const FALLBACK_UI_LABELS: UiLabels = { close: "Close" };

const UiLabelsContext: Context<UiLabels> =
  createContext<UiLabels>(FALLBACK_UI_LABELS);

export const UiLabelsProvider = UiLabelsContext.Provider;

export function useUiLabels(): UiLabels {
  return useContext(UiLabelsContext);
}
